/**
 * @generated SignedSource<<071ab1dcceebb811d1e96f913242f9c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChromePersonalCalendar_org$data = {
  readonly id: string;
  readonly domains: ReadonlyArray<string>;
  readonly " $fragmentType": "ChromePersonalCalendar_org";
};
export type ChromePersonalCalendar_org$key = {
  readonly " $data"?: ChromePersonalCalendar_org$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChromePersonalCalendar_org">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChromePersonalCalendar_org",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "domains",
      "storageKey": null
    }
  ],
  "type": "Org",
  "abstractKey": null
};

(node as any).hash = "aae9ee6a66ba508bc755a2b3bdec9f6a";

export default node;
